import React, { useState, useEffect } from 'react';

/**
 * Componente que muestra notificaciones temporales tipo toast
 * 
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.visible - Controla si el toast es visible
 * @param {string} props.message - Mensaje a mostrar en el toast
 * @param {string} props.type - Tipo de notificación ('success', 'error', 'info')
 * @param {Function} props.onDismiss - Función para cerrar la notificación
 * @returns {JSX.Element|null} El componente toast o null si no es visible
 */
const ToastNotification = ({ visible, message, type = "success", onDismiss }) => {
  // State para controlar la animación de salida
  const [isExiting, setIsExiting] = useState(false);
  
  // Efecto para manejar el auto-cierre del toast
  useEffect(() => {
    if (visible) {
      // Configurar el temporizador para cerrar automáticamente
      const autoCloseTimer = setTimeout(() => {
        setIsExiting(true);
        // Tiempo para la animación de salida
        setTimeout(() => {
          setIsExiting(false);
          if (onDismiss) onDismiss();
        }, 300);
      }, 3000);
      
      // Limpiar el temporizador si el componente se desmonta o el toast cambia
      return () => {
        clearTimeout(autoCloseTimer);
      };
    }
  }, [visible, message, onDismiss]);
  
  // No renderizar nada si el toast no es visible
  if (!visible) return null;
  
  // Elegir el icono según el tipo de notificación
  const getIcon = () => {
    switch (type) {
      case 'error':
        return '✕';
      case 'info':
        return 'i';
      default:
        return '✓';
    }
  };
  
  return (
    <div className={`scanner-toast ${isExiting ? 'toast-exit' : 'toast-enter'}`}>
      <div className={`scanner-toast-content ${type}`}>
        <span className={`scanner-toast-icon ${type}`}>
          {getIcon()}
        </span>
        <span>{message}</span>
      </div>
    </div>
  );
};

export default React.memo(ToastNotification);